import { network } from 'services/network';

import { QueryParams } from 'api/queries/clustersData.query';

export const getClusterData = (params: QueryParams) => {
    return network
        .post('api/bo/getClusterData', {
            clusterId: params.clusterId,
            paFileMetaDataIds: params.idList,
            clusterType: params.compare,
        })
        .then((response) => {
            return response.data;
        });
};
